export class Contact {
  _id;
  _name;
  _email;
  _phone;

  constructor(id, name, email, phone) {
    this._id = id;
    this._name = name;
    this._email = email;
    this._phone = phone;
  }

  get id() {
    return this._id;
  }

  get name() {
    return this._name;
  }

  get email() {
    return this._email;
  }

  get phone() {
    return this._phone;
  }

  set id(id) {
    this._id = id;
  }

  set name(name) {
    this._name = name;
  }

  set email(email) {
    this._email = email;
  }

  set phone(phone) {
    this._phone = phone;
  }

  static fromJson(json) {
    const id = json?.id || json?._id || '';
    return new Contact(id, json?.name, json?.email, json?.phone);
  }

  toJson() {
    return {
      id: this._id,
      name: this._name,
      email: this._email,
      phone: this._phone,
    };
  }

  clone() {
    return new Contact(this._id, this._name, this._email, this._phone);
  }

  toString() {
    return `Contact { id: ${this._id}, name: ${this._name}, email: ${this._email}, phone: ${this._phone} }`;
  }

  equals(contact) {
    return (
      this._id === contact.id &&
      this._name === contact.name &&
      this._email === contact.email &&
      this._phone === contact.phone
    );
  }

  static compare(contact1, contact2) {
    return contact1.equals(contact2);
  }

  static sort(contacts) {
    return contacts.sort((contact1, contact2) => {
      if (contact1.id < contact2.id) {
        return -1;
      }
      if (contact1.id > contact2.id) {
        return 1;
      }
      return 0;
    });
  }

  static filter(contacts, search) {
    return contacts.filter((contact) => {
      return (
        contact.id.includes(search) ||
        contact.name.includes(search) ||
        contact.email.includes(search) ||
        contact.phone.includes(search)
      );
    });
  }

  static validate(contact) {
    return (
      contact.id !== '' &&
      contact.name !== '' &&
      contact.email !== '' &&
      contact.phone !== ''
    );
  }

  static validateId(id) {
    return id !== '';
  }

  static validateName(name) {
    return name !== '';
  }

  static validateEmail(email) {
    return email !== '';
  }

  static validatePhone(phone) {
    return phone !== '';
  }

  static validateAll(contact) {
    return (
      Contact.validateId(contact.id) &&
      Contact.validateName(contact.name) &&
      Contact.validateEmail(contact.email) &&
      Contact.validatePhone(contact.phone)
    );
  }
}